import type {
  BrandColorName,
  UtilityColorName,
} from "containers/admin/clients/client/theme-configuration-page/theme-configuration.types";
import type { ColorsFormValues } from "containers/admin/clients/client/theme-configuration-page/brand-identity/colors-tab/colors-tab.types";

export const BRAND_COLOR_FIELDS: ReadonlyArray<{ name: BrandColorName; label: string }> = [
  { name: "primary", label: "Primary" },
  { name: "secondary", label: "Secondary" },
  { name: "tertiary", label: "Tertiary" },
];

export const UTILITY_COLOR_FIELDS: ReadonlyArray<{ name: UtilityColorName; label: string }> = [
  { name: "white", label: "White" },
  { name: "success", label: "Success" },
  { name: "warning", label: "Warning" },
  { name: "error", label: "Error" },
];

/** Figma's initial state: Neutral and Utility arrive pre-filled so the page never opens blank; Brand starts empty. */
export const DEFAULT_COLORS_FORM_VALUES: ColorsFormValues = {
  brand: { primary: "", secondary: "", tertiary: "" },
  neutral: { black: "#171717" },
  utility: { white: "#FFFFFF", success: "#22C55E", warning: "#FBBF24", error: "#DC2626" },
};

export const HEX_FORMAT_MESSAGE = "Please provide 6 characters for a valid hex code";
